import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_TARIF_SCHEMA_LITERAL = {
    title: 'Schéma Tarif',
    description: 'Tarif',
    version: 0,
    keyCompression: false,
    primaryKey: { key : 'CBMARQ_STR', fields : ['CBMARQ'], separator : '' },
    type: 'object',
    properties: {
        CBMARQ_STR: { type: 'string', maxLength : 10 },
        CBMARQ: { type: 'number' },
        TF_TYPE: { type: 'number' },
        TF_NO: { type: 'number' },
        TF_INTITULE: { type: ['string', 'null'] },
        TF_INTERES: { type: 'number' },
        TF_DEBUT: { type: ['string', 'null'] },
        TF_FIN: { type: ['string', 'null'] },
        TF_OBJECTIF: { type: ['number', 'null'] },
        TF_DOMAINE: { type: ['number', 'null'] },
        TF_BASE: { type: ['number', 'null'] },
        TF_CALCUL: { type: ['number', 'null'] },
        TF_TYPEP: { type: ['number', 'null'] },
        TF_TYPEPLIB: { type: ['string', 'null'] },
        AR_REF: { type: ['string', 'null'] },
        CT_NUM: { type: ['string', 'null'] },
        TF_REMISE01REM_VALEUR: { type: ['number', 'null'] },
        TF_REMISE01REM_TYPE: { type: ['number', 'null'] },
        TF_REMISE02REM_VALEUR: { type: ['number', 'null'] },
        TF_REMISE02REM_TYPE: { type: ['number', 'null'] },
        TF_REMISE03REM_VALEUR: { type: ['number', 'null'] },
        TF_REMISE03REM_TYPE: { type: ['number', 'null'] }
    },
    required: ['CBMARQ', 'TF_TYPE', 'TF_NO']
} as const;

const schemaTyped = toTypedRxJsonSchema(F_TARIF_SCHEMA_LITERAL);
export type RxFTarifDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_TARIF_SCHEMA: RxJsonSchema<RxFTarifDocumentType> = F_TARIF_SCHEMA_LITERAL;
